import { MenuItem, TextField, ListSubheader } from "@mui/material";
import { compareLeagueSelection } from "../helpers/leagueSelection";
import { LeagueDisplay } from "./LeagueDisplay";

export default function LeagueChoice({
  grouped = false,
  leagues,
  value,
  onChange,
  label,
  placeholder,
  disabled = false,
}) {
  const options = [...leagues].sort(compareLeagueSelection);
  return (
    <TextField
      select
      size="small"
      label={label}
      value={String(value ?? "")}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      InputLabelProps={{ shrink: true }}
      sx={{
        width: 340,
        maxWidth: "100%",
        my: 1,
        "& .MuiSelect-select": { color: "#f0f5f4", backgroundColor: "#172e3a" },
        "& .MuiInputLabel-root, & .MuiSvgIcon-root": { color: "#b6c6d2" },
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#526772" },
      }}
      SelectProps={{
        displayEmpty: true,
        MenuProps: {
          PaperProps: {
            sx: { bgcolor: "#172e3a", color: "#f0f5f4", maxHeight: "70vh" },
          },
        },
        renderValue: (v) => {
          const l = options.find((l) => String(l.id) === v);
          return l ? <LeagueDisplay league={l} compact /> : placeholder;
        },
      }}
    >
      {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
      {options.flatMap((l,index) => [
        ...(grouped && (index===0 || options[index-1].country?.name!==l.country?.name) ? [<ListSubheader key={`country-${l.id}`} sx={{bgcolor:"#172e3a",color:"#b6c6d2"}}>{l.country?.name || "International"}</ListSubheader>]:[]),
        <MenuItem key={l.id} value={String(l.id)}>
          <LeagueDisplay league={l} />
        </MenuItem>
      ])}
    </TextField>
  );
}
